import * as React from 'react';

import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';

const formControlStyle = theme => ({
    width: '100%',
    marginBottom: theme.spacing(1)
});


function SaisiePieceGestionCommercialeContent({ onChange, action }) {

    // Hook numéro commande client
    const [numeroCommandeClient, setNumeroCommandeClient] = React.useState('');

    //Hook numéro commande d'achat
    const [numeroCommandeAchat, setNumeroCommandeAchat] = React.useState('');

    // UseEffect sur la mise à jour
    React.useEffect(() => {
        onChange(null);
    }, [onChange]);

    // UseEffect sur les actions détails
    React.useEffect(() => {
        const getActionData = () => {

            if (numeroCommandeClient === '' && numeroCommandeAchat === '') {
                return null;
            }

            let actionData =
            {
                code: action.code,
                details: []
            };

            if (numeroCommandeClient) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.NumeroCommandeClient,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Numéro de commande client",
                    position: actionData.details.length,
                    valeurString: numeroCommandeClient
                });
            }
            if (numeroCommandeAchat) {
                actionData.details.push({
                    code: ReclamationActionDetailCodes.NumeroCommandeAchat,
                    type: ReclamationActionDetailType.Texte,
                    libelle: "Numéro de commande d'achat",
                    position: actionData.details.length,
                    valeurString: numeroCommandeAchat
                });
            }

            return actionData;
        }

        onChange(getActionData());
    }, [action.code, onChange, numeroCommandeClient, numeroCommandeAchat]);


    return (
        <DialogContent>

            <TextField
                sx={formControlStyle}
                value={numeroCommandeClient}
                onChange={e => setNumeroCommandeClient(e.target.value)}
                variant="filled"
                label="Numéro de commande client"
                placeholder="Veuillez indiquer le numéro de commande client"
                InputLabelProps={{
                    shrink: true,
                }}
            />

            <TextField
                sx={formControlStyle}
                value={numeroCommandeAchat}
                onChange={e => setNumeroCommandeAchat(e.target.value)}
                variant="filled"
                label="Numéro de commande d'achat"
                placeholder="Veuillez indiquer le numéro de commande d'achat"
                InputLabelProps={{
                    shrink: true,
                }}
            />

        </DialogContent>
    );
}

export default SaisiePieceGestionCommercialeContent;